<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';
import KnowledgeTab from './KnowledgeTab.vue';
import AnswersTab from './AnswersTab.vue';

defineProps({
  bot: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const VIEW_DOCUMENTS = 'documents';
const VIEW_ANSWERS = 'answers';

const viewItems = computed(() => [
  { key: VIEW_DOCUMENTS, label: t('AI_AGENT.KNOWLEDGE_HUB.DOCUMENTS') },
  { key: VIEW_ANSWERS, label: t('AI_AGENT.KNOWLEDGE_HUB.ANSWERS') },
]);

// The sub-tab lives in ?view= so the old /answers route can redirect here.
const activeView = computed(() =>
  route.query.view === VIEW_ANSWERS ? VIEW_ANSWERS : VIEW_DOCUMENTS
);

const activeViewIndex = computed(() =>
  viewItems.value.findIndex(item => item.key === activeView.value)
);

const onViewChanged = item => {
  if (item.key === activeView.value) return;
  router.replace({ query: { ...route.query, view: item.key } });
};
</script>

<template>
  <div class="flex flex-col gap-5">
    <TabBar
      :tabs="viewItems"
      :initial-active-tab="activeViewIndex"
      @tab-changed="onViewChanged"
    />
    <!-- v-if, not v-show: each child owns a ConfigForm that saves the whole
         bot_config, so only one may be mounted at a time. -->
    <AnswersTab
      v-if="activeView === VIEW_ANSWERS"
      :key="`answers-${bot.id}`"
      :bot="bot"
    />
    <KnowledgeTab v-else :key="`documents-${bot.id}`" :bot="bot" />
  </div>
</template>
